import { DialogContent, DialogContentText, Typography } from '@mui/material';
import React from 'react';
import ResponsiveDialogActions from '../ResponsiveDialogAction';
import { useDialogContext } from '../dialog-context';
import { keyframes } from '@mui/system';
import { useToastContext } from '../toast-context';
import { UploadCsv } from './uploadFile';
import UploadTable from './uploadGrid';
import { services } from '../../pages/Sell/services';
import { isEmpty } from 'lodash';

export const spin = keyframes`
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

export function UploadDialog() {
  const [assets, setAssets] = React.useState([]);
  const [failedAssets, setFailedAssets] = React.useState([]);
  const { showToast } = useToastContext();
  const { closeDialog } = useDialogContext();

  return (
    <DialogContent
      sx={{
        animation: `${spin} 400ms ease-out`,
        p: 4,
        direction: 'rtl',
        backgroundColor: 'transparent',
      }}
    >
      <UploadCsv setPrices={setAssets} setFailedAssets={setFailedAssets} />
      {!!failedAssets?.length && (
        <Typography width={'100%'} textAlign={'end'} mb={1}>
          لیست شمش‌های رد شده
        </Typography>
      )}
      {(!!assets?.length || !!failedAssets?.length) && (
        <UploadTable
          rows={!!failedAssets?.length ? failedAssets : assets}
          isFailed={!!failedAssets?.length}
        />
      )}

      <ResponsiveDialogActions
        onAccept={async () => {
          if (!isEmpty(assets)) {
            await services
              .setUploadData(assets)
              .then(res => {
                if (Number(res.data.data.failed) !== 0) {
                  setAssets([]);

                  setFailedAssets(res.data.data.failedSerials);
                  showToast('آپلود شمش ها با خطا مواجه شد.', 'error');
                  return;
                } else {
                  showToast(
                    `${res.data.data.successful} شمش با موفقیت ثبت شد.`,
                    'success'
                  );
                }
                closeDialog();
              })
              .catch(err => {
                showToast('آپلود با خطا مواجه شد.', 'error');
              });
          } else {
            showToast('فایلی انتخاب نشده است.', 'error');
          }
        }}
        onReject={closeDialog}
        acceptButtonProps={{
          sx: {
            py: 1.5,
            borderRadius: '12px',
            background: 'linear-gradient(45deg, #2dd4bf, #14b8a6)',
            color: '#fff',
            fontWeight: 600,
            boxShadow: '0 4px 12px rgba(16, 185, 129, 0.3)',
            transition:
              'background 0.3s ease, box-shadow 0.3s ease, transform 0.2s ease',
            '&:hover': {
              background: 'linear-gradient(45deg, #2dd4bf, #14b8a6)',
              transform: 'translateY(-2px)',
              boxShadow: '0 6px 16px rgba(16, 185, 129, 0.4)',
            },
            '&:disabled': {
              background: 'rgba(16, 185, 129, 0.5)',
              color: '#fff',
              boxShadow: 'none',
            },
          },
        }}
        rejectButtonProps={{
          sx: {
            py: 1.5,
            borderRadius: '12px',
            borderColor: '#f43f5e',
            color: '#f43f5e',
            fontWeight: 600,
            boxShadow: '0 4px 12px rgba(244, 63, 94, 0.3)',
            transition:
              'border-color 0.3s ease, color 0.3s ease, box-shadow 0.3s ease, transform 0.2s ease',
            '&:hover': {
              borderColor: '#e11d48',
              color: '#e11d48',
              transform: 'translateY(-2px)',
              boxShadow: '0 6px 16px rgba(244, 63, 94, 0.4)',
              backgroundColor: 'rgba(244, 63, 94, 0.05)',
            },
            '&:disabled': {
              borderColor: 'rgba(244, 63, 94, 0.5)',
              color: 'rgba(244, 63, 94, 0.5)',
              boxShadow: 'none',
            },
          },
        }}
      />
    </DialogContent>
  );
}
